import { API_STATUSES } from "../../_helpers/statuses";
import { API_CALLS } from "../_commonApiCalls/peopleApi";
import {
    getAllPeopleStatus,
    getAllPeopleData,
    getPeopleStatus,
    getPeopleData,
    getGroupsStatus,
    getGroupsData,
    savePersonData,
    savePersonStatus,
    getRfidAccessLevelStatus,
    getRfidAccessLevelData,
    editPersonStatus,
    editPersonData,
    saveRfidStatus,
    saveRfidData,
    updateRfidStatus,
    updateRfidData,
    getRFIDByTagStatus,
    getRFIDByTagData,
    deleteRfidByTagStatus,
    deleteRfidByTagData,
    transferRfidStatus,
    transferRfidData,
    assignNewRfidStatus,
    assignNewRfidData
} from "../_commonReducers/peopleReducers";

// ======================================================== Headers Configuration Start ================================== //
export const headersConfigData = () => {
    const credentialsData = localStorage.getItem("vkey");
    return {
        "Content-Type": "application/json",
        Authorization: "Basic " + credentialsData,
    };
};

// ======================================================== Headers Configuration End ==================================== //

const getAllPeopleService = () => {
    return async function getAllPeople(dispatch) {
        dispatch(getAllPeopleStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getAllPeopleApiCall(headersConfigData);
            let jsonResponse = await response.json();

            dispatch(getAllPeopleData(jsonResponse));
            dispatch(getAllPeopleStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getAllPeopleStatus(err));
            dispatch(getAllPeopleStatus(API_STATUSES.ERROR));
        }
    }
}

const getPeopleBySiteIdService = (siteId) => {
    return async function getPeopleBySiteId(dispatch) {
        dispatch(getPeopleStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getPeopleBySiteIdApiCall(
                siteId,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(getPeopleData(jsonResponse));
            dispatch(getPeopleStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getPeopleStatus(err));
            dispatch(getPeopleStatus(API_STATUSES.ERROR));
        }
    }
}

const getGroupsBySiteIdService = (siteId) => {
    return async function getGroups(dispatch) {
        dispatch(getGroupsStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getGroupsBySiteIdApiCall(
                siteId,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(getGroupsData(jsonResponse));
            dispatch(getGroupsStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getGroupsStatus(err));
            dispatch(getGroupsStatus(API_STATUSES.ERROR));
        }
    }
}

const savePersonService = (siteId, request) => {
    return async function savePerson(dispatch) {
        dispatch(savePersonStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.savePersonApiCall(
                siteId,
                request,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(savePersonData(jsonResponse));
            dispatch(savePersonStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(savePersonStatus(err));
            dispatch(savePersonStatus(API_STATUSES.ERROR));
        }
    }
}

const getRfidAccessLevelsService = () => {
    return async function getRfidAccessLevels(dispatch) {
        dispatch(getRfidAccessLevelStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getRfidAccessLevelsApiCall(
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(getRfidAccessLevelData(jsonResponse));
            dispatch(getRfidAccessLevelStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getRfidAccessLevelStatus(err));
            dispatch(getRfidAccessLevelStatus(API_STATUSES.ERROR));
        }
    }
}

const editPersonService = (siteId, personId, request) => {
    return async function savePerson(dispatch) {
        dispatch(editPersonStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.editPersonApiCall(
                siteId,
                personId,
                request,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(editPersonData(jsonResponse));
            dispatch(editPersonStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(editPersonStatus(err));
            dispatch(editPersonStatus(API_STATUSES.ERROR));
        }
    }
}

const saveRfidService = (siteId, request) => {
    return async function saveRfid(dispatch) {
        dispatch(saveRfidStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.saveRfidApiCall(
                siteId,
                request,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(saveRfidData(jsonResponse));
            dispatch(saveRfidStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(saveRfidStatus(err));
            dispatch(saveRfidStatus(API_STATUSES.ERROR));
        }
    }
}

const updateRfidService = (siteId, rfidId, request) => {
    return async function updateRfid(dispatch) {
        dispatch(updateRfidStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.updateRfidApiCall(
                siteId,
                rfidId,
                request,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(updateRfidData(jsonResponse));
            dispatch(updateRfidStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(updateRfidStatus(err));
            dispatch(updateRfidStatus(API_STATUSES.ERROR));
        }
    }
}

const getRFIDByTagService = (siteId, tag) => {
    return async function getRFIDByTag(dispatch) {
        dispatch(getRFIDByTagStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.getRFIDByTagApiCall(
                siteId,
                tag,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(getRFIDByTagData(jsonResponse));
            dispatch(getRFIDByTagStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(getRFIDByTagStatus(err));
            dispatch(getRFIDByTagStatus(API_STATUSES.ERROR));
        }
    }
}

const deleteRfidByTagService = (siteId, tag) => {
    return async function deleteRfidByTag(dispatch) {
        dispatch(deleteRfidByTagStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.deleteRfidByTagApiCall(
                siteId,
                tag,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(deleteRfidByTagData(jsonResponse));
            dispatch(deleteRfidByTagStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(deleteRfidByTagStatus(err));
            dispatch(deleteRfidByTagStatus(API_STATUSES.ERROR));
        }
    }
}

const transferRfidService = (siteId, request) => {
    return async function transferRfid(dispatch) {
        dispatch(transferRfidStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.transferRfidApiCall(
                siteId,
                request,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(transferRfidData(jsonResponse));
            dispatch(transferRfidStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(transferRfidStatus(err));
            dispatch(transferRfidStatus(API_STATUSES.ERROR));
        }
    }
}

const assignNewRfidService = (siteId, person) => {
    return async function assignNewRfid(dispatch) {
        dispatch(assignNewRfidStatus(API_STATUSES.REQUEST));
        try {
            let response = await API_CALLS.assignNewRfidApiCall(
                siteId,
                person,
                headersConfigData
            );
            let jsonResponse = await response.json();

            dispatch(assignNewRfidData(jsonResponse));
            dispatch(assignNewRfidStatus(API_STATUSES.SUCCESS));
        } catch (err) {
            dispatch(assignNewRfidStatus(err));
            dispatch(assignNewRfidStatus(API_STATUSES.ERROR));
        }
    }
}

export const PEOPLE_SERVICES = {   
    getAllPeopleService,
    getPeopleBySiteIdService,
    getGroupsBySiteIdService,
    savePersonService,
    getRfidAccessLevelsService,
    editPersonService,
    saveRfidService,
    updateRfidService,
    getRFIDByTagService,
    deleteRfidByTagService,
    transferRfidService,
    assignNewRfidService
};
